//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import { Params$AdminPayslipDocumentController_updateOneById } from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminPayslipDocumentController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminPayslipDocumentController_updateOneById,
    never
  >({ method: 'AdminPayslipDocumentController_updateOneById' });
